import { SmallText } from 'inpock-ui-react';

import * as S from './styled';

interface ProductRatingProps {
  average: string;
  count: number;
  onClick?: () => void;
}

export function ReviewRating(props: ProductRatingProps) {
  const { average, count, onClick } = props;
  return (
    <S.ProductRating>
      <div className="icon-star" />
      <SmallText>
        <span className="text-bold text-gray-700">{average}</span>{' '}
        <span className="text-underline text-gray-500 review-cnt" onClick={onClick}>
          리뷰 {count}개
        </span>
      </SmallText>
    </S.ProductRating>
  );
}
